/**
 * H2C Backend
 * An ASP.NET Core Web API for managing H2C User 
 *
 * The version of the OpenAPI document: V40:2026_02_04_10_21
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TH2LeistungDTO } from './tH2LeistungDTO';


export interface TH2AmountPerYearDTO { 
    year?: number;
    demand?: TH2LeistungDTO;
    production?: TH2LeistungDTO;
}

